var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientWidth>600)?_c('remCom',{attrs:{"datetime":_vm.datetime}}):_c('baseCom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }